import styles from "./ThreadListSkeleton.module.scss";

export default function ThreadListSkeleton() {
  return (
    <li data-skeleton>
      <div className={styles.button} />
      <div className={styles.dateBar} />
      {Array.from({ length: 30 }, (_, i) => (
        <div key={i} className={styles.row}>
          <span className={styles.icon} />
          <span
            className={styles.text}
            // Gives each skeleton row a different width to mimic varying thread titles.
            style={{ width: `${50 + ((i * 17) % 40)}%` }}
          />
          <span className={styles.dots} />
        </div>
      ))}
    </li>
  );
}
